import { createClientModule } from "@internal/backstage-plugin-utility-common";

import { GitHubGraphQLClient } from "./client/GitHubGraphQLClient";
import { GitHubRepoClient } from "./client/GitHubRepoClient";

export const gitHubGraphQLClientModule = createClientModule({
    pluginId: "github",
    moduleId: "graphql",
    path: "graphql",
    clientExtension: GitHubGraphQLClient,
});

export const gitHubRepoClientModule = createClientModule({
    pluginId: "github",
    moduleId: "repo",
    path: "repo",
    clientExtension: GitHubRepoClient,
});
